export { analyticsHandler, appEnvironment, trackEvent, initConsentGate } from 'libs/analytics';
